import { ActionRow } from '@types'

export const convertMenuPointActionsToRequestData = (actions: ActionRow[]) => {
  if (!actions) return undefined

  return actions.map(action => {
    const {
      objectFormTitle,
      actionTitle,
      eventTitle,
      objectFieldTitle,
      variable,
      contextMenu,
      tooltip,
      version,
      changed,
      createdOn,
      updatedOn,
      viewPreFilterScript,
      ...actionData
    } = action

    return {
      ...actionData,
      variableId: actionData.variableId ? actionData.variableId : variable?.id,
    }
  })
}
